import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { Catalog } from 'src/app/core/interfaces/catalog';
import { CatalogItem } from 'src/app/core/interfaces/catalogItem';
import { ParamsCargoList } from 'src/app/core/interfaces/paramsCargoList';
import { Utils } from 'src/app/core/resources/utils';
import { CargoService } from 'src/app/core/services/cargo.service';
import { CargoTripAnomalyService } from '../cargo-trip-anomaly/cargo-trip-anomaly.service';
import { CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { DateManager } from 'src/app/core/managers/date.manager';
import { Anomaly } from 'src/app/core/interfaces/anomaly';

@Component({
  selector: 'app-summary-anomaly-cargo-tracking',
  templateUrl: './summary-anomaly-cargo-tracking.component.html',
  styleUrls: ['./summary-anomaly-cargo-tracking.component.scss']
})
export class SummaryAnomalyCargoTrackingComponent implements OnInit {

  @Input() companyId: string;
  @Input() exclusive: boolean;
  @Output() filterAnomaly: EventEmitter<any> = new EventEmitter();;

  public anomalies: Anomaly[] = [];
  public colors: any[] = [];
  public cargos: Cargo[] = [];
  public dateLoad: string;
  public endDate: string;
  public countListAnomaly = {};

  constructor(
    private cargoTripAnomalyService: CargoTripAnomalyService,
    private cargoService: CargoService,
    public utils: Utils,
  ) { }

  ngOnInit() {
    this.dateLoad = DateManager.dateToString(DateManager.substract(new Date(), 20, 'days'), 'YYYY-MM-DD ZZ');
    this.endDate = DateManager.dateToString(new Date(), 'YYYY-MM-DD ZZ');
    this.getAnomalies();
  }

  private getAnomalies(): void {
    this.cargoTripAnomalyService.getTripAnomaly().subscribe(
      (success: Anomaly[]) => {
        this.anomalies = success.filter((anomaly) => {
          if (anomaly.name !== 'Otro') {
            this.countListAnomaly[anomaly.name] = [];
            return true;
          }
        });
        this.getListColors();
        this.getTotalCargo();
      });
  }

  private getListColors() {
    this.colors = this.utils.getRandomColorSize(this.anomalies.length + 1, true);
  }


  private getTotalCargo(): void {
    const params: ParamsCargoList = {};
    params.state = CargoStateEnum.START_SERVICE;

    if (!this.utils.isEmpty(this.companyId) && this.companyId != '-1') {
      params.nit = this.companyId;
    }
    if (!this.utils.isEmpty(this.exclusive)) {
      params.exclusive = this.exclusive;
    }
    if (!this.utils.isEmpty(this.dateLoad)) {
      params.dateLoad = this.dateLoad;
    }
    if (!this.utils.isEmpty(this.endDate)) {
      params.endDate = this.endDate;
    }
    this.cargoService.cargoList(params).subscribe(
      (response) => {
        if (response) {
          this.cargos = response.results;
          this.anomalies.forEach((anomaly => {
            this.countListAnomaly[anomaly.name] = this.cargos.filter(cargo => {
              const news = !this.utils.isEmpty(cargo.lastPointLocation) && !this.utils.isEmpty(cargo.lastPointLocation.news) ? cargo.lastPointLocation.news : null;
              return news === anomaly.name;
            });
          }));
        } else {
          this.cargos = [];
        }
      },
      (error) => {
      }
    );
  }

  public filterByAnomaly(data) {
    this.filterAnomaly.emit(data)
  }
}
